import { Component, OnChanges, Input } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-fleet-summary",
	templateUrl: "./fleet-summary.component.html",
	styleUrls: ["./fleet-summary.component.scss"]
})
export class FleetSummaryComponent implements OnChanges {
	@Input()
	fleet: APIResults.Fleet;

	public brand = BrandVars;

	constructor(private title: Title, private api: ApiService) { }

	ngOnChanges() {
		this.title.setTitle(BrandVars.appName);
	}
}
